import { Badge, Box, Grid, Typography } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import React, { useEffect, useState } from "react";
import { Bar, Pie, Line } from "react-chartjs-2";
import GaugeChart from "react-gauge-chart";
import { useLocation } from "react-router";
import CustomSelect from "../../../../../Components/CustomSelect";
import CustomSelectMulti from "../../../../../Components/CustomSelectMulti";
import DataService from "../../../../../Service";
import SettingsIcon from "@material-ui/icons/Settings";
import DashboardChartService from "./DashboardChartService";
import chartConstants from "./ChartConstants";
import ChartLoader from "./ChartLoader";
import { Button } from "@material-ui/core";
import { Popover } from "@material-ui/core";
import { DateRange } from "react-date-range";
import { makeStyles } from "@material-ui/core";
import moment from "moment";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import EvaluationRatingsGraph from "./AssignmentGraphs/EvaluationRatingsGraph";
let first = true ;
const useStyles = makeStyles((theme) => ({
  datePicker: {},
  datepickerPopover: {
    textAlign: "right",
    "& button": {
      backgroundColor: "#ffffff",
      border: "1px solid #d7dae2",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#ffffff",
      },
    },
  },

  selectClients: {
    "& .MuiSelect-select": {
      padding: "5px 8px !important",
    },
  },

  pieContainer: {
    width: "48.2%",
    transform: "translate(50%, 0)",
  },

  slaPieGraph: {
    width: "75%",
  },
  customTextField: {
    "& div": {
      padding: "0px !important",
      height: "47px",
    },
  },
}));

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: "right",
    },
  },
};
const graphBrandingColors = {
  evaluationRatings:"#6ABC91",
  objectivesByLeadership:"#40BAC6",
  mostUtilizedCoaches:"#3969A5",
  assignmentsPerMonth:["#078F47"	,"#40BAC6","#B5B440",	"#086e99","#A1A2A5"],
  assignmentBy:"#398BAD"
}
// const graphBrandingColors = {
//   evaluationRatings:"#007D82",
//   objectivesByLeadership:"#40BAC6",
//   mostUtilizedCoaches:"#07438f",
//   assignmentsPerMonth:["#078f47", "#07438f","#a3a110", "#40bac6","#086e99","#636569"],
//   assignmentBy:"#078F47"
// }

function Assignments(props) {
  const { isManageInfo } = props;
  props.setLoader(false);
  const [mostUtilizedCoach,setMostUtilizedCoach]=useState([
    { id: 1, name: "India", value: "India" },
    { id: 2, name: "UK", value: "UK" },
    { id: 3, name: "NewZealand", value: "NewZealand" },
  ])
  const classes = useStyles();
  const [userData, setUserData] = useState({
    assignment: "Status",
    organisation: "",
    perMonthDatatimePeriod: { byTime: "Last 6 months" ,
      byType: "by service" },
    avgDurationPeriod: "Last 6 months",
    assignmentMostUtilizeCoach: [],
    mostUtilizedLocation:""
  });
  //
  const [orgValue, setOrgValue] = useState("");

  const [inputValue, setInputValue] = React.useState("");
  // const [userData, setUserData] = useState({
  //   organisation_id: orgValue.id,
  //   sort_by: sortValue

  // });

  //

  const [orgListsArr, setOrgListsArr] = useState([]);
  const [org_attribute, setOrg_attribute] = useState([]);
  const [coach_attribute, setCoach_attribute] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [currentChartDataArr, setCurrentChartDataArr] = useState([]);
  const [checked, setChecked] = useState({});
  const [typeOpen, setTypeOpen] = React.useState(false);
  const [currentTypeChartDataArr, setCurrentTypeChartDataArr] = useState([]);
  const [typeChecked, setTypeChecked] = useState({});
  const [newOpen, setNewOpen] = React.useState(false);
  const [currentNewChartDataArr, setCurrentNewChartDataArr] = useState([]);
  const [newChecked, setNewChecked] = useState({});
  const [assignmentStatusChartData, setAssignmentStatusChartData] = useState(
    chartConstants.statusChartData
  );
  const [assignmentPerMonthData, setAssignmentPerMonthData] = useState(
    chartConstants.perMonthData
  );
  const [assignmentDurationData, setAssignmentDurationData] = useState(
    chartConstants.linedata
  );
  const [assignmentPieDurationData, setAssignmentPieDurationData] = useState(
    chartConstants.slaPieGraph
  );
  const [assignmentUtilizeCoach, setAssignmentUtilizeCoach] = useState(
    {...chartConstants.data}
  );
  const [assignmentCompetency, setAssignmentCompetency] = useState(
   { ...chartConstants.data}
  );
  const [evaluationTableData, setEvaluationTableData] = useState();
  const assignmentByTypeLayout = {...chartConstants.data};
  assignmentByTypeLayout.datasets[0].label = "Number of assignments";
  const [assignmentByType, setAssignmentByType] = useState(assignmentByTypeLayout);
  const [assignmentOptionsArr, setAssignmentOptionsArr] = useState([]);
  const [slaMatrixPercentage, setSlaMatrixPercentage] = useState(0);
  const [filterDataState, setFilterDataState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);
  const [anchorElPicker, setAnchorElPicker] = useState(null);

  //chartLoader

  const initialState = {
    organisationData: true,
    assignmentStatusChartData: true,
    assignmentByType: true,
    assignmentByUnitAndLocation: false,
    assignmentPieDurationData: true,
    objectiveByLeadership: false,
    sla_matrix: true,
    committedBusinessUnit: false,
    assignmentCompetency: true,
    assignmentPerMonthData: true,
    assignmentDurationData: true,
    assignmentUtilizeCoach: true,
    assignmentOptionsArr: true,
    evaluationTableData: true,
  };
const [mostUtilizedLocationArr,setMostUtilizedLocationArr]=useState([])

const getLocationArr = (orgId)=>{
  DataService.getData({organisation_id:orgId||undefined}, "mostUtilizedLocation").then((response) => {
    console.log(response,"response")
    const filter = response?.location_filter.map((el)=>{
      return el.value;
    })
    setMostUtilizedLocationArr(filter)

  }).catch(err=>{})
}
  const [chartLoader, setChartLoader] = useState({ ...initialState });

  const groupedCall = (organisationId, queryParams) => {
    getAssignmentStatusGraph(organisationId);
    getAssignmentMonthWiseCountGraph(organisationId,userData.perMonthDatatimePeriod);
    getAssignmentCompetency(organisationId, queryParams);
    getAssignmentByPieDuration(organisationId, queryParams);
    getAssignmentBySla(organisationId, queryParams);
  };

  useEffect(() => {
    getLocationArr();
    getOrganisationsData();
    getAssignmentOption();
    groupedCall(null, null);
    getAssignmentUtilizeCoach(null, null);
    getAssignmentDurationWiseGraph(null, null);
    getEvaluationRating(null);
    // getAssignmentBytypeGraph(null, null)

    return ()=>first=true;
  }, []);

  const getOrganisationsData = () => {
    DataService.getData({}, "organisations").then((response) => {
      orgListsArr.length = 0;

      var localArr = [
        {
          id: null,
          org_id: null,
          organisation_name: "All",
          internal_status: "All",
        },
        ...response.organisations,
      ];
      setOrgListsArr(orgListsArr.concat(localArr));

      setChartLoader((prev) => ({
        ...prev,
        organisationData: false,
      }));
    }).catch((err)=>{});
  };

  const openPicker = Boolean(anchorElPicker);
  const id = openPicker ? "simple-popover" : undefined;

  const handleClickPicker = (event) => {
    setAnchorElPicker(event.currentTarget);
  };

  const handleClosePicker = () => {
    setAnchorElPicker(null);
  };
  //updates//
  const organisationListHandler = (event, newValue) => {
    if (newValue === null) {
      newValue = "";
    }
    setOrgValue(newValue);
    setUserData((prev) => ({ ...prev, organisation: newValue.id }));
    setChartLoader({ ...initialState });

    groupedCall(newValue.id, null);
    getAssignmentBytypeGraph(newValue.id, userData.assignment);
    getAssignmentUtilizeCoach(newValue.id, null);
    getAssignmentDurationWiseGraph(newValue.id, null);
    getEvaluationRating(newValue.id);
    getLocationArr(newValue.id);
    setFilterDataState([
      {
        startDate:filterDataState[0]?.startDate,
        endDate:filterDataState[0]?.startDate,
        key: "selection",
      },
    ]);
    console.log(newValue,"new value")
  };
  //
  const onChangeItem = (selectedItemValue, inputId, routeFrom) => {
    console.log()
    var currentOrg = orgListsArr.filter(
      (option) => option.organisation_name == userData.organisation
    );
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
    console.log(selectedItemValue,"selected item")
    // if (selectedItemValue.id === "organisation") {
    //   setChartLoader({ ...initialState })
    //   currentOrg = orgListsArr.filter(
    //     (option) => option.organisation_name == selectedItemValue.value
    //   );
    //   groupedCall(currentOrg[0].id, null);
    //   getAssignmentBytypeGraph(currentOrg[0].id, null)
    //   getAssignmentUtilizeCoach(currentOrg[0].id, null);
    //   getAssignmentDurationWiseGraph(currentOrg[0].id, null);
    //   setFilterDataState([
    //     {
    //       startDate: currentOrg[0].from_date,
    //       endDate: currentOrg[0].end_date,
    //       key: "selection",
    //     },
    //   ]);
    // }
    if (selectedItemValue.id === "perMonthDatatimePeriod") {
      const forFilter = userData.perMonthDatatimePeriod.byTime;
      const forSubfilter = userData.perMonthDatatimePeriod.byType;

      const newUserPerMonthData = { ...userData };
      let reqArray = [];
      if (selectedItemValue.dataIndex === 0) {
        reqArray = [
          { byTimeValue: selectedItemValue.value },
          { byTypeValue: forSubfilter },
        ];
      }
      if (selectedItemValue.dataIndex === 1) {
        reqArray = [
          { byTimeValue: forFilter },
          { byTypeValue: selectedItemValue.value },
        ];
      }
      newUserPerMonthData.perMonthDatatimePeriod.byTime =
        reqArray[0].byTimeValue;
      newUserPerMonthData.perMonthDatatimePeriod.byType =
        reqArray[1].byTypeValue;

      setUserData(newUserPerMonthData);

      getAssignmentMonthWiseCountGraph(
        orgValue.id || currentOrg[0]?.id ,
        newUserPerMonthData.perMonthDatatimePeriod
      );
    }

    if (selectedItemValue.id === "avgDurationPeriod") {
      getAssignmentDurationWiseGraph(
        orgValue.id || currentOrg[0]?.id,
        selectedItemValue.value
      );
    }
    if (selectedItemValue.id === "mostUtilizedLocation") {
      getAssignmentUtilizeCoach(orgValue.id || currentOrg[0]?.id,selectedItemValue.value);
    }
    // console.log(currentOrg,orgValue,"organisation name")
    if(selectedItemValue.id==="evaluation"){
      getEvaluationRating( orgValue?.id || null,
        selectedItemValue.value)
    }
    if (selectedItemValue.id === "assignment") {
      getAssignmentBytypeGraph(
        orgValue ? orgValue.id : null,
        selectedItemValue.value
      );
    }
  };

  const onChangeMultiItem = (obj, inputId, routeFrom) => {
    if (inputId == "org_attributes") {
      org_attribute.length = 0;
      setOrg_attribute(org_attribute.concat(obj));
    }
    if (inputId == "coach_attributes") {
      coach_attribute.length = 0;
      setCoach_attribute(coach_attribute.concat(obj));
      var currentOrg = orgListsArr.filter(
        (option) => option.organisation_name == userData.organisation
      );
      const values = obj.map((option) => option.value);
      const newData = { ...userData, assignmentMostUtilizeCoach: values };
      setUserData(newData);
      getAssignmentUtilizeCoach(
        userData.organisation || null ,
        newData.assignmentMostUtilizeCoach
      );
    }
  };

  const getAssignmentStatusGraph = (organisationId) => {
    var pdata =
      organisationId == null ? "" : "?organisation_id=" + organisationId;
    DataService.getDirectData(
      "dashboards/assignment_status_graph" + pdata,
      {}
    ).then((response) => {
      if (response.data?.length) {
        const updateAssignmentStatusChartData = {
          ...assignmentStatusChartData,
        };
        // console.log(organisationId,"more")
        if(response.data.length > 2 && !organisationId){
          // console.log(response.data.length,organisationId,"org")
          updateAssignmentStatusChartData.selectOrg = true;
        }else{
          updateAssignmentStatusChartData.selectOrg = false;
          updateAssignmentStatusChartData.datasets[0].data =
            response.data[0].value;
          updateAssignmentStatusChartData.labels = response.data[0].labels;
          updateAssignmentStatusChartData.datasets[0].label ="Number of assignments";
        }

        setAssignmentStatusChartData(updateAssignmentStatusChartData);
        var localArr = [];
        var checkedData = {};
        response.data[0].labels.map((option, i) => {
          var pdata = {};
          pdata["checked"] = true;
          pdata["name"] = option;
          pdata["value"] = updateAssignmentStatusChartData.datasets[0].data[i];
          checkedData[option] = true;
          localArr.push(pdata);
        });
        setChecked({ ...checked, ...checkedData });
        setCurrentChartDataArr(localArr);
      }
      setChartLoader((prev) => ({ ...prev, assignmentStatusChartData: false }));
    }).catch((err)=>{});
  };

  const getAssignmentBytypeGraph = (organisationId, assignmentType) => {
    const paramData = assignmentType;
    var pdata = "?filter=" + paramData;
    if (organisationId) {
      pdata = pdata + "&organisation_id=" + organisationId;
    }
    DataService.getDirectData("dashboards/assignments_graph" + pdata, {}).then(
      (response) => {setAssignmentByType((prev)=>{          
        const updatedAssignmentByType = { ...prev };
        const filteredData = response.data.filter((el)=>!(el.key===null || el.key ==="" ) && el.value>0)
          updatedAssignmentByType.datasets[0].data = filteredData.map(el=>el.value);
          updatedAssignmentByType.labels = filteredData.map(el=>el.key);
          updatedAssignmentByType.datasets[0].backgroundColor = graphBrandingColors.assignmentBy;
          updatedAssignmentByType.datasets[0].borderColor = graphBrandingColors.assignmentBy;
        if(assignmentType==="Service"){
          updatedAssignmentByType.labels = filteredData.map((e) => e.key.charAt(0).toUpperCase() +e.key.slice(1)); 
          }
        return updatedAssignmentByType; 
      })
      let localArr = [];
      let checkedData = {};
      setAssignmentByType((prev)=>{
        prev.labels.forEach((option, i) => {
          var pdata = {};
          pdata["checked"] = true;
          pdata["name"] = option;
          pdata["value"] = prev.datasets[0].data[i];
          checkedData[option] = true;
          localArr.push(pdata);
        });
        return prev
      })
      setTypeChecked(prev=>({ ...prev, ...checkedData }));
      setCurrentTypeChartDataArr(localArr);
        setChartLoader((prev) => ({ ...prev, assignmentByType: false }));
      }
    ).catch((err)=>{});
  };

  const getAssignmentByPieDuration = (organisationId) => {
    var pdata =
      organisationId == null
        ? "?filter=2021"
        : "?filter=2021&organisation_id=" + organisationId;
    DataService.getDirectData(
      "dashboards/quarterly_assignment_count_graph" + pdata,
      {}
    ).then((response) => {
      const updatedAssignmentPieDurationData = { ...assignmentPieDurationData };
      updatedAssignmentPieDurationData.datasets[0].data = response.data.map(
        (data) => data.value
      );
      updatedAssignmentPieDurationData.labels = response.data.map(
        (data) => data.key
      );
      setAssignmentPieDurationData(updatedAssignmentPieDurationData);
      setChartLoader((prev) => ({ ...prev, assignmentPieDurationData: false }));
    }).catch((err)=>{});
  };

  const getAssignmentBySla = (organisationId) => {
    var pdata =
      organisationId == null ? "" : "?organisation_id=" + organisationId;
    DataService.getDirectData("dashboards/sla_matrix" + pdata, {}).then(
      (response) => {
        setSlaMatrixPercentage(response.sla_matrix);
        setChartLoader((prev) => ({ ...prev, sla_matrix: false }));
      }
    ).catch((err)=>{});
  };

  const getAssignmentCompetency = (organisationId) => {
    var pdata =
      organisationId == null ? "" : "?organisation_id=" + organisationId;
    DataService.getDirectData("dashboards/competency_graph" + pdata, {}).then(
      (response) => {
        const updatedAssignmentCometency = { ...assignmentCompetency };
        const distinct = {};
        response.competency_graph.forEach((el)=>{
          if(distinct[el.competency]){
            distinct[el.competency] = distinct[el.competency] + el.count
          }else{
            distinct[el.competency] = el.count
          }
        })
        updatedAssignmentCometency.datasets[0].data = Object.values(distinct);
        updatedAssignmentCometency.datasets[0].backgroundColor = graphBrandingColors.objectivesByLeadership;
        updatedAssignmentCometency.datasets[0].borderColor = graphBrandingColors.objectivesByLeadership;
        updatedAssignmentCometency.datasets[0].label = "Number of assignments"
        updatedAssignmentCometency.labels = Object.keys(distinct); 
        //   updatedAssignmentCometency.datasets[0].data =
        //   response.competency_graph.map((data) => data.count);
        //   updatedAssignmentCometency.datasets[0].label = "Number of assignments"
        // updatedAssignmentCometency.labels = response.competency_graph.map(
        //   (data) => data.competency);
        setAssignmentCompetency(updatedAssignmentCometency);
        setChartLoader((prev) => ({ ...prev, assignmentCompetency: false }));
      }
    ).catch((err)=>{});
  };
  const getAssignmentMonthWiseCountGraph = (
    organisationId,
    perMonthDatatimePeriod
  ) => {
    console.log(perMonthDatatimePeriod,"data console",organisationId)
    const filData = perMonthDatatimePeriod ? perMonthDatatimePeriod.byTime : "";
    // var pdata = "";
    // if (organisationId) {
    //   pdata =  "?organisation_id=" + organisationId;
    // }
    // if(filData){
    //   pdata = pdata===" "?"?":"&"+"filter=" + filData;
    // }
    // if (perMonthDatatimePeriod) {
    //   pdata = pdata + "&sub_filter=" + perMonthDatatimePeriod.byType;
    // }

    DataService.getDirectData(
      "dashboards/monthwise_assignment_count_graph",
      {organisation_id:organisationId,filter:filData,sub_filter:perMonthDatatimePeriod.byType}
    ).then((response) => {
      const responseArray = [response.data];
      const updatedAssignmentPerMonthData = { ...assignmentPerMonthData };
      const DataArray = responseArray.map(
        (data) => Object.values(data)
      )?.flatMap((el)=>el);
      // updatedAssignmentPerMonthData.datasets[0].label = "Assignments Per Month";
      updatedAssignmentPerMonthData.labels = responseArray.map(
        (data) => Object.keys(data)
      )?.flatMap((el)=>el);
      const obj={};
      const dataSet = DataArray.map((el)=>{
        for(let i in el){
          if(obj[i]){
            obj[i]=[...obj[i],el[i]]
          }else{
            obj[i]=[el[i]]
          }
        }
      })
      // const backgroundColor = [
      //   "#078f47",
      //   "#07438f",
      //   "#a3a110",
      //   "#40bac6",
      //   "#086e99",
      //   "#636569",
      // ];
      const backgroundColor=graphBrandingColors.assignmentsPerMonth;
      updatedAssignmentPerMonthData.datasets= Object.entries(obj)?.filter((el)=>el[0]!=="Not applicable").map((el,ind)=>{
        return {
          label:el[0],data:el[1],backgroundColor:backgroundColor[ind%6],borderColor:backgroundColor[ind%6]
        }
        // console.log(el,"element")
      }) 
      // console.log(newData,"element")
      // console.log(updatedAssignmentPerMonthData,responseArray,DataArray,"updated assigment");
      setAssignmentPerMonthData(updatedAssignmentPerMonthData);
      setChartLoader((prev) => ({ ...prev, assignmentPerMonthData: false }));
    }).catch((err)=>console.error(err));
  };
  const getAssignmentDurationWiseGraph = (
    organisationId,
    avgDurationPeriod
  ) => {
    const avgDuration = avgDurationPeriod || "";
    var pdata = "?filter=" + avgDuration;
    if (organisationId) {
      pdata = pdata + "&organisation_id=" + organisationId;
    }

    DataService.getDirectData(
      "dashboards/monthwise_assignment_duration_graph" + pdata,
      {}
    ).then((response) => {
      const updatedAssignmentDurationData = { ...assignmentDurationData };
      updatedAssignmentDurationData.datasets[0].label = "Average duration";
      updatedAssignmentDurationData.datasets[0].data = response.data.map(
        (data) => data.value
      );
      updatedAssignmentDurationData.labels = response.data.map(
        (data) => data.key
      );
      setAssignmentDurationData(updatedAssignmentDurationData);
      setChartLoader((prev) => ({ ...prev, assignmentDurationData: false }));
    }).catch((err)=>{});
  };

  const getAssignmentUtilizeCoach = (organisationId, assignmentDetail) => {
    setChartLoader((prev) => ({ ...prev, assignmentUtilizeCoach: true }));
    const mostUtilized = assignmentDetail !== null ? assignmentDetail : "";
    const { startDate, endDate } = filterDataState[0];
    const params = {location_filter:mostUtilized||undefined,
      organisation_id:organisationId||undefined,
    }
    if(startDate ){
      params.from_date=moment(startDate).format("MMMM YY");
    }
    if(endDate){
      params.end_date=moment(endDate).format("MMMM YY");
    }
    DataService.getDirectData(
      "dashboards/most_utilised_coaches_graph",
      params
    ).then((response) => {
      
      if (response.data.length > 0) {
        const backgroundColor = [
          "#07438f",
          "#078f47",
          "#a3a110",
          "#40bac6",
          "#086e99",
          "#636569",
        ];
        console.log(response.data,"updated coach")
        const sortedResponseNames = response.data.map(el=>el.coach_name).sort();
        const sortedData =sortedResponseNames?.map(el=>{
         return  response.data.find((ell)=>ell.coach_name===el)
        }) || response.data
        const updatedMostUtilizeCoach = { ...assignmentUtilizeCoach };
      //   const newDataSet = [];
      //   const dataArray=[];
      //   const locationSet = [...new Set(response.data.map(el=>el.locations).flatMap(el=>el))];
      //   const locationArray =
      //    locationSet.length>0
      //       ? locationSet
      //       : mostUtilizedCoach.map((e) => e.value);
      //   // const locationArray = ["India", "New zealand"]
      //  const dropDown = locationSet.map((el,ind)=>{
      //   return {
      //     id:ind+1,name:el,value:el
      //   }
      //  })
      //  if(first){
      //      setMostUtilizedCoach(dropDown);
      //      first=false;
      //    }
      //   locationArray.map((e, index) => (newDataSet[index] = { label: e }));
      //   newDataSet.map(
      //     (e, index) =>
      //       (e.backgroundColor = backgroundColor[index < 6 ? index : index - 6])
      //   );          
      //   response.data.forEach((el)=>{
      //     const finalData = new Array(locationSet.length).fill(0);
      //     if(el.count.length>0 && el.locations.length>0){
      //       if(el.count?.length === el.locations?.length){
      //         for(let i=0;i<el.count.length;i++){
      //           finalData[locationSet.indexOf(el.locations[i])]=el.count[i]
      //         } 
              
      //       }
      //     }
      //     dataArray.push(finalData) ;
      //   })
      //   newDataSet.map((e, index) => (e.data = dataArray.map((e) => e[index])));  

        updatedMostUtilizeCoach.datasets[0].data = sortedData?.map((el)=>el.count);
        updatedMostUtilizeCoach.labels = sortedData?.map(
          (data) => data.coach_name
        );
        updatedMostUtilizeCoach.datasets[0].backgroundColor=graphBrandingColors.mostUtilizedCoaches;
        updatedMostUtilizeCoach.datasets[0].borderColor=graphBrandingColors.mostUtilizedCoaches;

        // console.log(updatedMostUtilizeCoach,"updated utilize")
        setAssignmentUtilizeCoach(updatedMostUtilizeCoach);
        var localArr = [];
        var checkedData = {};
        const labelsArray = updatedMostUtilizeCoach.labels || assignmentUtilizeCoach.labels
        labelsArray?.map((option, i) => {
          var pdata = {};
          pdata["checked"] = true;
          pdata["name"] = option;
          pdata["value"] = updatedMostUtilizeCoach.datasets[0]?.data[i];
          checkedData[option] = true;
          localArr.push(pdata);
        });
        setNewChecked({ ...newChecked, ...checkedData });
        setCurrentNewChartDataArr(localArr);
      }else{
        setAssignmentUtilizeCoach((prev)=>{
          const updatedGraph = {...prev};
          updatedGraph.datasets[0].data=[]
          updatedGraph.labels=[];
          return updatedGraph
          setNewChecked({ });
      setCurrentNewChartDataArr([]);
        })}
      setChartLoader((prev) => ({ ...prev, assignmentUtilizeCoach: false }));
    }).catch((err)=>{});
  };

  const getAssignmentOption = (organisationId, assignmentMostUtilizeCoach) => {
    var pdata =
      organisationId == null ? "" : "?organisation_id=" + organisationId;
    DataService.getDirectData(
      "dashboards/assignments_graph_dropdown_options" + pdata,
      {}
    ).then((response) => {
      assignmentOptionsArr.length = 0;
      setAssignmentOptionsArr(assignmentOptionsArr.concat(response.data));
      setUserData({ ...userData, assignment: response.data[0] });
      getAssignmentBytypeGraph(organisationId, response.data[0]);
      setChartLoader((prev) => ({ ...prev, assignmentOptionsArr: false }));
    }).catch((err)=>{});
  };

  ///
  const getEvaluationRating = (organisationId,filter) => {
    var pdata =
      organisationId == null ? "" : "?organisation_id=" + organisationId;

    DataService.getDirectData(
      "dashboards/evaluation_dashboard" + pdata,
      {filter:filter?filter:undefined}
    ).then((response) => {
      setEvaluationTableData(response.data);
      setChartLoader((prev) => ({ ...prev, evaluationTableData: false }));
    }).catch((err)=>console.error(err));
  };

  ///
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = (value) => {
    setOpen(false);
  };
  const handleClickTypeOpen = () => {
    setTypeOpen(true);
  };
  const handleTypeClose = (value) => {
    setTypeOpen(false);
  };

  const handleClickNewOpen = () => {
    setNewOpen(true);
  };
  const handleNewClose = (value) => {
    setNewOpen(false);
  };

  const afterUpdateGraph = (objArr, checkedArr) => {
    const filteredCurrentChartDataArr = objArr.filter(
      (option) => option.checked
    );
    const newAssignmentStatusChartData = { ...assignmentStatusChartData };
    newAssignmentStatusChartData.datasets[0].data =
      filteredCurrentChartDataArr.map((option, i) => option.value);
    newAssignmentStatusChartData.labels = filteredCurrentChartDataArr.map(
      (option, i) => option.name
    );
    setAssignmentStatusChartData(newAssignmentStatusChartData);
    setChecked(checkedArr);
    handleClose();
  };
  const afterUpdateTypeGraph = (objArr, checkedArr) => {
    const filteredCurrentChartDataArr = objArr.filter(
      (option) => option.checked
    );
    const newAssignmentByType = { ...assignmentByType };
    newAssignmentByType.datasets[0].data = filteredCurrentChartDataArr.map(
      (option, i) => option.value
    );
    newAssignmentByType.labels = filteredCurrentChartDataArr.map(
      (option, i) => option.name
    );
    setAssignmentByType(newAssignmentByType);
    setTypeChecked(checkedArr);
    handleTypeClose();
  };
  const afterUpdateNewGraph = (objArr, checkedArr) => {
    const filteredCurrentChartDataArr = objArr.filter(
      (option) => option.checked
    );
    const newAssignmentUtilizeCoach = { ...assignmentUtilizeCoach };
    newAssignmentUtilizeCoach.datasets[0].data =
      filteredCurrentChartDataArr.map((option, i) => option.value);
    newAssignmentUtilizeCoach.labels = filteredCurrentChartDataArr.map(
      (option, i) => option.name
    );
    setAssignmentUtilizeCoach(newAssignmentUtilizeCoach);
    setNewChecked(checkedArr);
    handleNewClose();
  };

  useEffect(() => {
    if (
      filterDataState[0]?.startDate !== filterDataState[0]?.endDate ||
      (filterDataState[0]?.startDate === "" &&
        filterDataState[0]?.endDate === "")
    ) {
      // setLoadingCount(3);
      props.setLoader(true);
      getAssignmentUtilizeCoach(
        userData.organisation,
        userData.assignmentMostUtilizeCoach
      );
      getAssignmentDurationWiseGraph(
        userData.organisation,
        userData.avgDurationPeriod
      );
      // getAssignmentBytypeGraph(userData.organisation, null)
      groupedCall(
        userData.organisation,
        "from_date=" +
          moment(filterDataState[0]?.startDate).format("MMMM YY") +
          " " +
          new Date().getFullYear() +
          "&end_date=" +
          moment(filterDataState[0]?.endDate).format("MMMM YY") +
          " " +
          (new Date().getFullYear() + 1)
      );
      getEvaluationRating(userData.organisation);
      setAnchorElPicker(null);
    }
  }, [filterDataState]);

  const labels = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
  ];
  const ShowPieData =
    assignmentPieDurationData.datasets[0].data.filter((e) => e !== 0).length > 0
      ? true
      : false;
  return (
    <Grid>
      <Box
        style={{
          position: "sticky",
          top: isManageInfo ? "168px" : "120px",
          backgroundColor: "#fff",
          zIndex: 2,
          padding: "16px 0px 0 0px",
          boxShadow: "0px 3px 0px 7px #ffffff",
        }}
      >
        {" "}
        <Grid container xs={12} spacing={1}>
          <Grid item xs={8}></Grid>

          <Grid item xs={2}>
            {" "}
            <Box>
              {/* <Button
                disableElevation
                style={{
                  backgroundColor: "#077f83",
                  color: "#fff",
                  textTransform: "none",
                  // marginLeft: "-19px"
                  float: "right",
                }}
              >
                <SettingsIcon
                  style={{ marginRight: 10, fontSize: 14, cursor: "pointer" }}
                />
                Customize view
              </Button> */}
            </Box>
          </Grid>
          {/* <Grid item xs={2}>
            <Box>
              <Button
                disableElevation
                style={{
                  backgroundColor: "#EF7000",
                  color: "#fff",
                  textTransform: "none",
                  // marginLeft: "2px"
                  // float: 'right'
                }}
              >
                <GetAppIcon style={{ marginRight: 10, fontSize: 14 }} />
                Download xls
              </Button>
            </Box>
          </Grid> */}
        </Grid>
        <br />
        <Grid container item xs={12}>
          <Grid item xs={6}>
            <Autocomplete
              value={orgValue}
              onChange={organisationListHandler}
              classes={{
                input: classes.autoComplete,
                option: classes.autoComplete,
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              // autoHighlight={true}
              id="controllable-states-demo"
              options={orgListsArr}
              getOptionLabel={(option) => option.organisation_name}
              renderInput={(params) => (
                <TextField
                  {...params}
                  className={classes.customTextField}
                  inputProps={{
                    ...params.inputProps,
                    style: { fontSize: "16px" },
                  }}
                  placeholder="Organisation name"
                  style={{ fontSize: "20px" }}
                  autoFocus
                  variant="outlined"
                />
              )}
            />
            {/* <CustomSelect
              id="organisation"
              labelText="Select Organization"
              displayEmpty
              variant="outlined"
              itemArr={orgListsArr.map((option) => option.organisation_name)}
              parentcall={onChangeItem}
              MenuProps={{
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                getContentAnchorEl: null,
              }}
              defaultValue={userData.organisation}
            /> */}
          </Grid>
          <Grid item xs={6}>
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              {filterDataState[0]?.startDate ? (
                <AddCircleIcon
                  onClick={() => {
                    setFilterDataState([
                      {
                        key: "selection",
                        startDate: "",
                        endDate: "",
                      },
                    ]);
                  }}
                  fontSize="large"
                  color="error"
                  style={{
                    cursor: "pointer",
                    transform: "rotate(45deg)",
                    marginRight: "10px",
                  }}
                />
              ) : null}
              <div className={classes.datepickerPopover}>
                <Button
                  aria-describedby={id}
                  variant="contained"
                  onClick={handleClickPicker}
                >
                  {filterDataState[0]?.startDate
                    ? moment(filterDataState[0]?.startDate).format("DD/MM/YYYY")
                    : "DD/MM/YYYY"}{" "}
                  -{" "}
                  {filterDataState[0]?.endDate
                    ? moment(filterDataState[0]?.endDate).format("DD/MM/YYYY")
                    : "DD/MM/YYYY"}
                </Button>
                <Popover
                  id={id}
                  open={openPicker}
                  anchorEl={anchorElPicker}
                  onClose={handleClosePicker}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                  }}
                  transformOrigin={{
                    vertical: "center",
                    horizontal: "center",
                  }}
                >
                  <DateRange
                    className={classes.datePicker}
                    editableDateInputs={true}
                    onChange={(item) => setFilterDataState([item.selection])}
                    moveRangeOnFirstSelection={false}
                    ranges={filterDataState}
                    startDatePlaceholder="Start date"
                    endDatePlaceholder="End date"
                    dateDisplayFormat="dd/MM/yyyy"
                  />
                </Popover>
              </div>
            </div>
          </Grid>
        </Grid>
      </Box>

      <Grid container spacing={3} style={{ marginTop: "0.5rem" }}>
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      color="secondary"
                      style={{
                        height: "47px",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        fontWeight="fontWeightBold"
                        style={{ marginLeft: "26px" }}
                      >
                        Assignment by
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    <CustomSelect
                      className={classes.selectClients}
                      id="assignment"
                      labelText="Select Clients"
                      displayEmpty
                      hideLable
                      variant="outlined"
                      itemArr={assignmentOptionsArr}
                      parentcall={onChangeItem}
                      MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left",
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left",
                        },
                        getContentAnchorEl: null,
                      }}
                      defaultValue={userData.assignment}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Box textAlign="center">
                      <Badge color="primary" onClick={handleClickTypeOpen}>
                        <SettingsIcon style={{ cursor: "pointer" }} />
                      </Badge>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box width={1}>
              {chartLoader.assignmentByType ? (
                <ChartLoader />
              ) : (
                <AssignmentByTypeBar
                  organisation={userData.organisation}
                  assignmentByType={assignmentByType}
                  options={chartConstants.options}
                />
              )}{" "}
            </Box>
          </Box>
        </Grid>
        {/* <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      color="secondary"
                      style={{
                        height: "47px",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        fontWeight="fontWeightBold"
                        style={{ marginLeft: "26px" }}
                      >
                        Assignments by business unit and location
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <CustomSelectMulti
                      className={classes.selectClients}
                      id="org_attributes"
                      itemArr={[]}
                      parentcall={onChangeMultiItem}
                      placeholder="Select location"
                      value={org_attribute}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Box width={1}>
                {chartLoader.assignmentByUnitAndLocation ? (
                  <ChartLoader />
                ) : (
                  <AssignmentByUnitAndLocation
                    organisation={userData.organisation}
                    assignmentByUnitandLocation={
                      chartConstants.unitAndLocationData
                    }
                    options={chartConstants.options}
                  />
                )}
              </Box>
            </Grid>
          </Box>
        </Grid> */}
      {/* </Grid>
      <Grid container spacing={3} style={{ marginTop: "0.5rem" }}> */}
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={11}>
                    <Typography
                      variant="subtitle1"
                      color="secondary"
                      style={{
                        height: "47px",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        fontWeight="fontWeightBold"
                        style={{ marginLeft: "26px" }}
                      >
                        Assignment status - Chemistry/Session/Completed
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Box textAlign="center">
                      <Badge color="primary" onClick={handleClickOpen}>
                        <SettingsIcon style={{ cursor: "pointer" }} />
                      </Badge>
                    </Box>
                  </Grid>
                </Grid>
                <Box width={1}>
                  {chartLoader.assignmentStatusChartData ? (
                    <ChartLoader />
                  ) : (
                    <AssignmentByStatus
                      organisation={userData.organisation}
                      assignmentByStatus={assignmentStatusChartData}
                      options={chartConstants.options}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        {/* <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  style={{
                    height: "59px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <Box
                    fontWeight="fontWeightBold"
                    style={{ marginLeft: "26px" }}
                  >
                    {" "}
                    New assignments by quarter
                  </Box>
                </Typography>
              </Grid>
            </Grid>
            <Box width={1}>
              <Box width={1} className={classes.pieContainer}>
                {chartLoader.assignmentPieDurationData ? (
                  <ChartLoader />
                ) : ShowPieData ? (
                  <AssignmentByPieData
                    organisation={userData.organisation}
                    assignmentPieDurationData={assignmentPieDurationData}
                    options={options}
                  />
                ) : (
                  <Grid
                    style={{
                      height: "215px",
                      textAlign: "center",
                      paddingTop: "140px",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    No chart data available
                  </Grid>
                )}
              </Box>
            </Box>
          </Box>
        </Grid> */}
      {/* </Grid>
      <Grid container spacing={3} style={{ marginTop: "0.5rem" }}> */}
        {/* <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  style={{
                    height: "47px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <Box
                    fontWeight="fontWeightBold"
                    style={{ marginLeft: "26px" }}
                  >
                    Objectives by leadership capability framework
                  </Box>
                </Typography>
              </Grid>
            </Grid>
            <Box width={1}>
              {chartLoader.objectiveByLeadership ? (
                <ChartLoader />
              ) : (
                <ObjectiveByLeadership
                  organisation={userData.organisation}
                  objectiveByLeadership={chartConstants.leadershipData}
                  options={chartConstants.horizontaloptions}
                />
              )}
            </Box>
          </Box>
        </Grid> */}
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  style={{
                    height: "47px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <Box
                    fontWeight="fontWeightBold"
                    style={{ marginLeft: "26px" }}
                  >
                    SLA metrics
                  </Box>
                </Typography>
              </Grid>
            </Grid>
            <Box width={1} style={{ padding: "57px" }}>
              <Box width={1} className={classes.slaPieGraph}>
                {chartLoader.sla_matrix ? (
                  <ChartLoader />
                ) : (
                  <AssignmentByGauge
                    assignmentByGauge={{
                      id: userData.organisation,
                      nrOfLevels: 100,
                      arcsLength: [0.4, 0.5, 0.1],
                      colors: ["#EC9706", "#636569", "#078f47"],
                      percent: slaMatrixPercentage / 100,
                      arcPadding: 0.02,
                      textColor: "#232323",
                    }}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Grid>
      {/* </Grid>
      <Grid container spacing={3} style={{ marginTop: "0.5rem" }}> */}
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      color="secondary"
                      style={{
                        height: "47px",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        fontWeight="fontWeightBold"
                        style={{ marginLeft: "26px" }}
                      >
                        Average duration of assignments
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <CustomSelect
                      variant="outlined"
                      id="avgDurationPeriod"
                      labelText="Select time period"
                      parentcall={onChangeItem}
                      placeholder="Last 6 months"
                      itemArr={["Last 6 months", "Last 12 months"]}
                      defaultValue={userData.avgDurationPeriod}
                    />
                  </Grid>
                </Grid>
                <Box width={1}>
                  {chartLoader.assignmentDurationData ? (
                    <ChartLoader />
                  ) : (
                    <AssignmentByAverageDuration
                      organisation={userData.organisation}
                      assignmentByAverageDuration={assignmentDurationData}
                      options={chartConstants.options}
                    />
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Grid>
        {/* <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Typography
                  variant="subtitle1"
                  color="secondary"
                  style={{
                    height: "47px",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <Box
                    fontWeight="fontWeightBold"
                    style={{ marginLeft: "26px" }}
                  >
                    Committed spend business unit
                  </Box>
                </Typography>
              </Grid>
            </Grid>
            <Box width={1}>
              {chartLoader.committedBusinessUnit ? (
                <ChartLoader />
              ) : (
                <CommittedBusinessUnit
                  organisation={userData.organisation}
                  committedBusinessUnit={chartConstants.businessUnitData}
                  options={chartConstants.options}
                />
              )}
            </Box>
          </Box>
        </Grid> */}
      {/* </Grid>

      <Grid container spacing={3} style={{ marginTop: "0.5rem" }}> */}
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      color="secondary"
                      style={{
                        height: "47px",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        fontWeight="fontWeightBold"
                        style={{ marginLeft: "26px" }}
                      >
                        Most utilised coaches
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={5}>
                    {/* <CustomSelectMulti
                      id="coach_attributes"
                      itemArr={mostUtilizedCoach}
                      parentcall={onChangeMultiItem}
                      placeholder="Select Location"
                      value={coach_attribute}
                    /> */}
                    <CustomSelect
                      className={classes.selectClients}
                      variant="outlined"
                      id="mostUtilizedLocation"
                      labelText="Select location"
                      parentcall={onChangeItem}
                      placeholder="Select location"
                      displayEmpty
                      itemArr={mostUtilizedLocationArr}
                      defaultValue={userData.mostUtilizedLocation}
                      dataIndex={0}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Box textAlign="center">
                      <Badge color="primary" onClick={handleClickNewOpen}>
                        <SettingsIcon style={{ cursor: "pointer" }} />
                      </Badge>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
              <Box width={1}>
                {chartLoader.assignmentUtilizeCoach ? (
                  <ChartLoader />
                ) : (
                  <AssignmentByMostUtilizedCoaches
                    organisation={userData.organisation}
                    assignmentByMostUtilizedCoaches={assignmentUtilizeCoach}
                    options={{
                      plugins: {
                        title: {
                          display: true,
                          text: "",
                        },
                      },
                      responsive: true,
                      interaction: {
                        mode: "index",
                        intersect: false,
                      },
                      // scales: {
                      //   x: {
                      //     stacked: true,
                      //   },
                      //   y: {
                      //     stacked: true,
                      //     max: 10,
                      //     min: 0,
                      //     ticks: { stepSize: 1,major:true },
                      //     grid: {
                      //       drawTicks: false,
                      //     },
                      //   },alignToPixels:true,weight:10
                      // },
                      scales:{
                        y:{
                          ticks:{
                            stepSize:1
                          },grace:"50%"
                        }
                      }
                    }}
                  />
                )}
              </Box>
            </Grid>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Grid item xs={12}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      color="secondary"
                      style={{
                        height: "47px",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        fontWeight="fontWeightBold"
                        style={{ marginLeft: "26px" }}
                      >
                        Assignments per month over a period
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={3} style={{ paddingRight: "16px" }}>
                    <CustomSelect
                      className={classes.selectClients}
                      variant="outlined"
                      id="perMonthDatatimePeriod"
                      labelText="Select Time Period"
                      parentcall={onChangeItem}
                      placeholder="Last 6 months"
                      itemArr={["Last 6 months", "Last 12 months"]}
                      defaultValue={userData.perMonthDatatimePeriod.byTime}
                      dataIndex={0}
                    />
                  </Grid>
                  <Grid item xs={3} style={{ padding: "0 8px 0 8px" }}>
                    <CustomSelect
                      className={classes.selectClients}
                      variant="outlined"
                      id="perMonthDatatimePeriod"
                      labelText="Select Service"
                      parentcall={onChangeItem}
                      placeholder="by service"
                      itemArr={["by service", "by service type"]}
                      defaultValue={userData.perMonthDatatimePeriod.byType}
                      dataIndex={1}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Box>
              {chartLoader.assignmentPerMonthData ? (
                <ChartLoader />
              ) : (
                <AssignmentByPerMonth
                  organisation={userData.organisation}
                  assignmentByPerMonth={assignmentPerMonthData}
                  options={chartConstants.options}
                />
              )}
            </Box>
          </Box>
        </Grid>
{/* 
      </Grid>

      <Grid container spacing={3} style={{ marginTop: "0.5rem" }}> */}
        {/* <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center" >
              <Grid item xs={12}  style={{paddingLeft:"1rem",paddingRight:"1rem"}}>
                <Grid container direction="row" alignItems="center">
                  <Grid item xs={6}>
                    <Typography
                      variant="subtitle1"
                      color="secondary"
                      style={{
                        height: "47px",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      <Box
                        fontWeight="fontWeightBold"
                        style={{ marginLeft: "0px" }}
                      >
                        Evaluation ratings
                      </Box>
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <CustomSelect
                      className={classes.selectClients}
                      id="evaluation"
                      labelText="Select assignments"
                      displayEmpty
                      variant="outlined"
                      itemArr={["Yes", "No"]}
                      parentcall={onChangeItem}
                      defaultValue={userData.evaluation}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {chartLoader.evaluationTableData ? (
              <ChartLoader />
            ) : (
              <EvaluationTable evaluationTableData={evaluationTableData} />
            )}
          </Box>
        </Grid> */}
        <Grid item xs={6}>
          <Box boxShadow={4} p={1} style={{ borderRadius: "5px" }}>
            <Grid container direction="row" alignItems="center">
              <Typography
                variant="subtitle1"
                color="secondary"
                style={{
                  height: "47px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <Box fontWeight="fontWeightBold" style={{ marginLeft: "26px" }}>
                  Objectives by leadership capability framework
                </Box>
              </Typography>
            </Grid>
            <Box width={1}>
              {chartLoader.assignmentCompetency ? (
                <ChartLoader />
              ) : (
                <AssignmentByCompetency
                  organisation={userData.organisation}
                  assignmentByCompetency={assignmentCompetency}
                  options={chartConstants.horizontaloptions}
                />
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <EvaluationRatingsGraph organisationId={orgValue} plainView={false} graphColor={graphBrandingColors.evaluationRatings} />
        </Grid>
      </Grid>
      {open && (
        <DashboardChartService
          currentChartDataArr={currentChartDataArr}
          setCurrentChartDataArr={setCurrentChartDataArr}
          afterUpdateGraph={afterUpdateGraph}
          open={open}
          handleClose={handleClose}
          grpahChecked={checked}
          assignmentList={true}
        />
      )}
      {typeOpen && (
        <DashboardChartService
          assignmentList={true}
          currentChartDataArr={currentTypeChartDataArr}
          setCurrentChartDataArr={setCurrentTypeChartDataArr}
          afterUpdateGraph={afterUpdateTypeGraph}
          open={typeOpen}
          handleClose={handleTypeClose}
          grpahChecked={typeChecked}
        />
      )}
      {newOpen && (
        <DashboardChartService
        assignmentList={true}
          currentChartDataArr={currentNewChartDataArr}
          setCurrentChartDataArr={setCurrentNewChartDataArr}
          afterUpdateGraph={afterUpdateNewGraph}
          open={newOpen}
          handleClose={handleNewClose}
          grpahChecked={newChecked}
        />
      )}
    </Grid>
  );
}

export default Assignments;

//////
const NotFoundFallback = (props) => {
  return (
    <Box
      style={{
        width: "100%",
        height: "23.5rem",
        maxHeight: "23.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography
        component={"p"}
        style={{ fontWeight: 800, fontSize: "1.1rem" }}
      >
        {props.text?props.text:"Data not found"}
      </Typography>
    </Box>
  );
};

const AssignmentByTypeBar = React.memo(
  (props) => {
    const dataLength = props.assignmentByType.datasets[0].data.length;
    const labelLength = props.assignmentByType.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={assignmentByType}
            data={props.assignmentByType}
            // options={chartConstants.options}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByType) ===
      JSON.stringify(nextProps.assignmentByType)
    );
  }
);

const AssignmentByUnitAndLocation = React.memo(
  (props) => {
    const dataLength =
      props.assignmentByUnitandLocation.datasets[0].data.length;
    const labelLength = props.assignmentByUnitandLocation.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={chartConstants.data}
            data={props.assignmentByUnitandLocation}
            // options={chartConstants.options}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByUnitandLocation) ===
      JSON.stringify(nextProps.assignmentByUnitandLocation)
    );
  }
);

const AssignmentByStatus = React.memo(
  (props) => {
    const dataLength = props.assignmentByStatus.datasets[0].data.length;
    const labelLength = props.assignmentByStatus.labels.length;
    const selectOrg = props.assignmentByStatus.selectOrg;
    console.log(selectOrg,"select org")
    return (
      <>
        {!selectOrg?(dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={assignmentStatusChartData}
            data={props.assignmentByStatus}
            // options={chartConstants.options}
            options={chartConstants.options}
          />
        ) : (
          <NotFoundFallback  />
        )):<NotFoundFallback text="Please select an organisation "/>}
      </>
    );
  },

  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByStatus) ===
      JSON.stringify(nextProps.assignmentByStatus)
    );
  }
);

const AssignmentByPieData = React.memo(
  (props) => {
    const dataLength = props.assignmentByStatus.datasets[0].data.length;
    const labelLength = props.assignmentByStatus.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Pie
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={assignmentPieDurationData}
            data={props.assignmentPieDurationData}
            options={props.options}
            // options={chartConstants.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentPieDurationData) ===
      JSON.stringify(nextProps.assignmentPieDurationData)
    );
  }
);

const ObjectiveByLeadership = React.memo(
  (props) => {
    const dataLength = props.objectiveByLeadership.datasets[0].data.length;
    const labelLength = props.objectiveByLeadership.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={chartConstants.data}
            data={props.objectiveByLeadership}
            // options={chartConstants.horizontaloptions}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.objectiveByLeadership) ===
      JSON.stringify(nextProps.objectiveByLeadership)
    );
  }
);

const AssignmentByGauge = React.memo(
  (props) => (
    <GaugeChart
      key={Math.random()}
      id={props.assignmentByGauge.id}
      nrOfLevels={props.assignmentByGauge.nROfLevels}
      arcsLength={props.assignmentByGauge.arcsLength}
      colors={props.assignmentByGauge.colors}
      percent={props.assignmentByGauge.percent}
      arcPadding={props.assignmentByGauge.arcPadding}
      textColor={props.assignmentByGauge.textColor}
    />
  ),
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByGauge) ===
      JSON.stringify(nextProps.assignmentByGauge)
    );
  }
);
const AssignmentByAverageDuration = React.memo(
  (props) => {
    const dataLength =
      props.assignmentByAverageDuration.datasets[0].data.length;
    const labelLength = props.assignmentByAverageDuration.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Line
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={assignmentDurationData}
            data={props.assignmentByAverageDuration}
            // options={chartConstants.options}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByAverageDuration) ===
      JSON.stringify(nextProps.assignmentByAverageDuration)
    );
  }
);

const CommittedBusinessUnit = React.memo(
  (props) => {
    const dataLength = props.committedBusinessUnit.datasets[0].data.length;
    const labelLength = props.committedBusinessUnit.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={chartConstants.data}
            data={props.committedBusinessUnit}
            // options={chartConstants.options}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.committedBusinessUnit) ===
      JSON.stringify(nextProps.committedBusinessUnit)
    );
  }
);

const AssignmentByMostUtilizedCoaches = React.memo(
  (props) => {
    const dataLength =
      props.assignmentByMostUtilizedCoaches.datasets[0].data.length;
    const labelLength = props.assignmentByMostUtilizedCoaches.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data={assignmentUtilizeCoach}
            data={props.assignmentByMostUtilizedCoaches}
            // options={inline-options}
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByMostUtilizedCoaches) ===
      JSON.stringify(nextProps.assignmentByMostUtilizedCoaches)
    );
  }
);

const AssignmentByPerMonth = React.memo(
  (props) => {
    const dataLength = props.assignmentByPerMonth.datasets.length;
    const labelLength = props.assignmentByPerMonth.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            // id={userData.organisation}
            id={props.organisation}
            // data = { assignmentPerMonthData }}
            data={props.assignmentByPerMonth}
            // /options = { chartConstants.options }
            options={props.options}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByPerMonth) ===
      JSON.stringify(nextProps.assignmentByPerMonth)
    );
  }
);

const AssignmentByCompetency = React.memo(
  (props) => {
    const dataLength = props.assignmentByCompetency.datasets[0].data.length;
    const labelLength = props.assignmentByCompetency.labels.length;
    return (
      <>
        {dataLength > 0 && labelLength > 0 ? (
          <Bar
            key={Math.random()}
            id={props.organisation}
            // id={userData.organisation}
            data={props.assignmentByCompetency}
            // data={assignmentCompetency}
            options={props.options}
            // options={chartConstants.horizontaloptions}
          />
        ) : (
          <NotFoundFallback />
        )}
      </>
    );
  },
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.assignmentByCompetency) ===
      JSON.stringify(nextProps.assignmentByCompetency)
    );
  }
);

const EvaluationTable = React.memo(
  (props) => (
    <>
      <br />
      <Grid item xs={12} style={{paddingLeft:"1rem",paddingRight:"1rem"}}>
        <Grid
          container
          direction="row"
          spacing={2}
          style={{ backgroundColor: "#F5F6FA", height: 45, paddingTop: 10,paddingLeft:"1rem",paddingRight:"1rem"}}
        >
          <Grid item xs={5}>
            <Typography variant="h2">
              <Box fontWeight="fontWeightBold">Coach name</Box>
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <Typography variant="h2">
              <Box fontWeight="fontWeightBold">
                Average rating across assignments
              </Box>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      {props.evaluationTableData.length > 0 ? (
        props.evaluationTableData.map((option) => {
          return (
            <Grid item xs={12}  style={{paddingLeft:"1rem",paddingRight:"1rem"}}>
              <Grid container direction="row" style={{paddingLeft:"1rem",paddingRight:"1rem"}} spacing={2} gap={1} >
                <Grid item xs={6} style={{ paddingTop: "10px" }}>
                  <Typography variant="h2">
                    {option.coach_name ? (
                      <Box>{option.coach_name}</Box>
                    ) : (
                      <Box alignItems="center" paddingLeft={"2px"}>
                        -
                      </Box>
                    )}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ paddingTop: "10px", marginLeft: "-43px" }}
                >
                  <Typography variant="h2">
                    <Box>{option.average}</Box>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          );
        })
      ) : (
        <Grid item xs={12} style={{ height: "25.3vh" }}>
          <Typography
            variant="subtitle1"
            style={{ paddingTop: 68, textAlign: "center" }}
          >
            No data available
          </Typography>
        </Grid>
      )}
    </>
  ),
  (preProps, nextProps) => {
    return (
      JSON.stringify(preProps.evaluationTableData) ===
      JSON.stringify(nextProps.evaluationTableData)
    );
  }
);
